import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { MassAssignRequestModel } from 'Pages/orders'

export const massAssignProductsApi = {
	sendMassAssignRequestApi: async (data: MassAssignRequestModel) => {
		const res = await axiosDS().patch(`${urls.orders.mass_assign_products}`, { data })
		return res.data
	},
}
